export default __webpack_public_path__ + "static/media/PPE SIMULATOR.e7a9d71e.jpg";